import { defineNuxtPlugin } from '#app'
import '@splidejs/splide/css';

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.provide('splide', async () => {
    const { Splide } = await import('@splidejs/splide')
    return Splide
  })
})
